import Controller from '@ember/controller';
import { ApplicationModel } from 'login/routes/application';

export default class ForgotPasswordController extends Controller<ApplicationModel> {}
